import { ButtonComponent } from "@syncfusion/ej2-react-buttons";

import {
  TabComponent,
  TabItemDirective,
  TabItemsDirective,
} from "@syncfusion/ej2-react-navigations";
import React, { useEffect, useState } from "react";
import MobileManagement from "./mobile/mobile";
import ReclaimScanManagement from "./reclaimScan/reclaimScan";
import AddSettingsScreen from "../addScreen/addScreen";
import { setRowData } from "../../grid/gridReducer";
import { ReactComponent as Add } from "../../../icons/AddNew.svg";
import { ReactComponent as Download } from "../../../icons/download.svg";

import axios from "axios";
import notify from "../../../services/toasterService";
import {
  setLanguageData,
  setMobileMsgData,
  setReclaimScanMsgData,
} from "../settingsReducers";
//import { getSettingsEndPoint } from "../utils";
import { messageManagemetnSettingsEndPoint } from "../utils";
import { useDispatch } from "react-redux";
import ExcelService from "../../../services/excel";

const childTab = [{ text: "Reclaim Scan" }, { text: "Mobile" }];
const reclaimScan = () => {
  return <ReclaimScanManagement />;
};

const mobile = () => {
  return <MobileManagement />;
};

const MessageManagement = () => {
  const dispatch = useDispatch();

  const [addScreen, setAddScreen] = useState(false);
  const [addScreenTabName, setAddScreenTabName] = useState(null);

  let TabData: any = [];
  let selectedTab: string;

  useEffect(() => {
    selectedTab = "Reclaim Scan";
    messageManagamentTabApi(selectedTab);
  });

  const TabChangeEvent = async (e: any) => {
    dispatch(setRowData([]));
    // console.log(e.selectingIndex, e.selectingItem.innerText);
    selectedTab = e.selectingItem.innerText;
    await messageManagamentTabApi(e.selectingItem.innerText);
  };

  const handlePopupActionLocation = (selectedTabName: any) => {
    setAddScreen(true);
    setAddScreenTabName(selectedTabName);
  };

  const excelExport = () => {
    ExcelService.exportAsExcel('',selectedTab, TabData);
  };

  /**
   * Message management Sub tabs Get WS
   * @author Manikanta
   * @param TabName - Selected Tab name
   */
  const messageManagamentTabApi = async (TabName: any) => {
    const endPointURL = messageManagemetnSettingsEndPoint(TabName);
    await axios
      .get(endPointURL)
      .then((res) => {
        if (TabName === "Reclaim Scan") {
          dispatch(setReclaimScanMsgData(res.data));
        } else if (TabName === "Mobile") {
          dispatch(setMobileMsgData(res.data));
        }
        getLanguages("Languages");
        TabData = res.data;
      })
      .catch((err) => {
        notify("Failed to fetch data", "error");
      });
  };

  const getLanguages = async (tabName: any) => {
    const endPointURL = messageManagemetnSettingsEndPoint(tabName);
    await axios
      .get(endPointURL)
      .then((res) => {
        if (tabName === "Languages") {
          dispatch(setLanguageData(res.data));
        }
      })
      .catch((err) => {
        notify("Failed to update data", "error");
      });
  };

  return (
    <div>
      {addScreen && (
        <AddSettingsScreen
          addScreen={addScreen}
          setAddScreen={setAddScreen}
          tabName={addScreenTabName}
        />
      )}

      <div className="col-sm-12 col-md-12 col-lg-12 pt-5">
        <div className="col-sm-6">
          <p className="settings-tab-title fw-bold">Message Management</p>
        </div>
        <div className="col-sm-6 pr-0">
          <ButtonComponent
            type="button"
            className="iconCopy float-right ml-1"
            onClick={() => handlePopupActionLocation(selectedTab)}
          >
            <Add />
          </ButtonComponent>

          <ButtonComponent
            className="iconCopy float-right ml-1"
            onClick={() => excelExport()}
          >
            <Download />
          </ButtonComponent>
        </div>
      </div>

      <div className="col-sm-12 col-md-12 col-lg-12 ">
        <div className="control-pane">
          <div className="control-section tab-control-section">
            <TabComponent
              heightAdjustMode="Auto"
              cssClass="orientation-tab ll-custom-tab ll-tab-width"
              selecting={TabChangeEvent}
            >
              <TabItemsDirective>
                <TabItemDirective header={childTab[0]} content={reclaimScan} />

                <TabItemDirective header={childTab[1]} content={mobile} />
              </TabItemsDirective>
            </TabComponent>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MessageManagement;
